import { Component, OnInit, Input } from '@angular/core';
import { FrontpageService } from '../../Services/frontpage.service';
import * as $ from 'jquery';
import { AuthService } from '../../Services/auth.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-home-card-center-show',
  template: require('./home-card-center-show.component.html'),
  styles: [require('./home-card-center-show.component.css')]
})
export class HomeCardCenterShowComponent implements OnInit {
  @Input('position') position: string;

  items : any[] = [];

  constructor(private frontPageService: FrontpageService, private auth: AuthService) { }

  ngOnInit() {
    this.refreshAll()
  }

  refreshAll(){
    // console.log("Refresh Center Show")
    this.frontPageService.getAllFrontPageItems(this.position).subscribe(res => {
        this.items = res;
        // console.log(res);
    });
  }

  showModal(item: any){
    var url = '/uploads/frontpage/' + item.image;

    $('.modal-body').attr('src', url);
        (<any>$('#myModal')).modal({
            show: true
    });

    $('.modal-title').text(item.title);
  }

  deleteOtherItem(i: number) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
            var index = this.items.findIndex(x => x.id==i);
            this.items.splice(index, 1);
            this.frontPageService.delete(i).subscribe(res =>{
              // console.log(res);
            });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/home-card-center-show/home-card-center-show.component.ts